import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { API_URL } from "../../Config";

const InvoicePDF = () => {
  const { bookingid } = useParams();
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/invoice/${bookingid}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setBooking(data.data);
        }
      });
  }, [bookingid]);
  const [searchParams] = useSearchParams();
  const autoprint = searchParams.get("autoprint") === "1";

  useEffect(() => {
    if (!booking || !autoprint) return;

    const timer = setTimeout(() => {
      window.print();
    }, 1000);

    return () => clearTimeout(timer);
  }, [booking, autoprint]);
  useEffect(() => {
    if (!autoprint) return;
    const handleAfterPrint = () => {
      window.close();
    };
    window.addEventListener("afterprint", handleAfterPrint);
    return () => window.removeEventListener("afterprint", handleAfterPrint);
  }, [autoprint]);

  if (!booking) return <div>Loading...</div>;
  const subtotal = Number(booking.btocprice || 0);
  // const totgst = booking.totgst || 0;
  const total = booking.finalprice || booking.totalprice || 0;
  const roundedTotal = Math.round(total);
  const proprice = booking.proprice || 0;
  const roundedproprice = Math.round(proprice);

  const securityDeposit = booking.secdep || 0;
  const roundedSecurityDeposit = Math.round(securityDeposit);

  // const cgst = subtotal * 0.09;
  // const sgst = subtotal * 0.09;
  // const totgst = cgst + sgst;
  const inclusiveGst =
    booking.isinclusive === 1 ||
    booking.isinclusive === "1" ||
    booking.isinclusive === true;

  const cgst = inclusiveGst ? 0 : Number((subtotal * 0.09).toFixed(2));
  const sgst = inclusiveGst ? 0 : Number((subtotal * 0.09).toFixed(2));
  const totgst = Number((cgst + sgst).toFixed(2));
  const displayGst = inclusiveGst ? -totgst : totgst;
  const numberToWords = (num) => {
    const belowTwenty = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const convertBelowThousand = (n) => {
      let str = "";
      if (n >= 100) {
        str += belowTwenty[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n >= 20) {
        str += tens[Math.floor(n / 10)] + " ";
        n %= 10;
      }
      if (n > 0) {
        str += belowTwenty[n] + " ";
      }
      return str.trim();
    };

    if (num === 0) return "Zero Rupees Only";

    let result = "";

    if (num >= 10000000) {
      result += convertBelowThousand(Math.floor(num / 10000000)) + " Crore ";
      num %= 10000000;
    }

    if (num >= 100000) {
      result += convertBelowThousand(Math.floor(num / 100000)) + " Lakh ";
      num %= 100000;
    }

    if (num >= 1000) {
      result += convertBelowThousand(Math.floor(num / 1000)) + " Thousand ";
      num %= 1000;
    }

    if (num > 0) {
      result += convertBelowThousand(num);
    }

    return result.trim() + " Rupees Only";
  };

  const totalWordsFormatted = numberToWords(total);
  const formatDate = (date) => new Date(date).toLocaleDateString("en-GB");

  const nights =
    Math.ceil(
      (new Date(booking.checkout) - new Date(booking.checkin)) /
        (1000 * 60 * 60 * 24),
    ) || 0;

  // ── Build one row per villa ──
  const safeDate = (d) => {
    if (!d) return "-";
    const x = new Date(d);
    return isNaN(x) ? "-" : x.toLocaleDateString("en-GB");
  };
  const calcNights = (cin, cout) => {
    if (!cin || !cout) return 0;
    const diff = (new Date(cout) - new Date(cin)) / (1000 * 60 * 60 * 24);
    return isNaN(diff) ? 0 : Math.max(0, Math.ceil(diff));
  };

  let raw = booking.propertydetails;
  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch {
      raw = null;
    }
  }

  let rows = [];
  if (Array.isArray(raw) && raw.length) {
    rows = raw.map((pd, i) => ({
      property: pd.property || pd.name || `Property ${i + 1}`,
      checkin: pd.checkin || booking.checkin,
      checkout: pd.checkout || booking.checkout,
      rate: pd.proprice || booking.proprice || 0,
      amount: pd.totpay || pd.btocprice,
    }));
  } else if (raw && typeof raw === "object" && Object.keys(raw).length) {
    rows = Object.keys(raw).map((name) => {
      const pd = raw[name] || {};
      return {
        property: pd.property || name,
        checkin: pd.checkin || booking.checkin,
        checkout: pd.checkout || booking.checkout,
        rate: pd.proprice || booking.proprice || 0,
        amount: pd.totpay || pd.btocprice,
      };
    });
  } else {
    rows = [
      {
        property: booking.property,
        checkin: booking.checkin,
        checkout: booking.checkout,
        rate: booking.proprice || 0,
        amount: booking.btocprice,
      },
    ];
  }

  return (
    <div className="p-3 bg-[#fafaf9] text-[12px] font-sans">
      <div className="bg-[#fafaf9] p-5 rounded-lg max-w-[900px] mx-auto">
        {/* Header */}
        <div className="w-full flex justify-between mb-3">
          {/* Left */}
          <div className="w-[45%] pr-3">
            <h1 className="text-[28px] font-semibold mb-2 ml-2">Invoice</h1>

            <div className="ml-2 text-[11px] leading-4">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7c57c4a2-564b-4b83-62b0-761f834b5c00/public"
                alt="logo"
                className="h-[50px] w-auto my-2 block"
              />

              <p>306, 7 - Business Centrum</p>
              <p>Amin Marg, Rajkot, 360001</p>
              <p>GSTIN No.: 24AADFZ2976K1ZO</p>
            </div>
          </div>

          {/* Middle */}
          <div className="w-[30%] pt-10 text-[11px]">
            <p className="font-semibold">Contact</p>
            <p>
              <a
                href="https://www.zorbastays.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black no-underline"
              >
                www.zorbastays.com
              </a>
            </p>
            <p>+91 63552 31066</p>
          </div>

          {/* Right */}
          <div className="w-[25%] flex justify-end">
            <img
              src="https://zorbastays.com/android-chrome-512x512.png"
              //   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe4aa1c0-bc53-4764-85e9-7823b8961200/public"
              alt="brand"
              className="w-20 h-20 rounded-full"
            />
          </div>
        </div>

        <hr className="my-1" />

        {/* Invoice Meta */}
        <div className="flex justify-between text-[11px] my-2">
          <div>
            <p>Invoice No.</p>
            <p className="font-semibold">{booking.bookingid}</p>
          </div>
          <div>
            <p>Invoice Date</p>
            <p className="font-semibold">
              {new Date().toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        <hr className="my-1" />

        {/* Invoice To */}
        <div className="mt-4">
          <p className="text-[16px] font-semibold mb-1">Invoice To</p>
          <p className="text-[18px] uppercase">
            {booking.firstname} {booking.lastname}
          </p>
        </div>

        {/* Table */}
        <div className="mt-5 overflow-x-auto">
          <table className="w-full border-collapse text-[11px] border-b border-gray-300">
            <thead>
              <tr>
                <th className="border-t border-gray-300 p-1 text-center">
                  Sr. No.
                </th>
                <th className="border-t border-l border-gray-300 p-1 text-center">
                  Particulars
                </th>
                <th className="border-t border-gray-300 p-1 text-center">
                  Period of stay
                </th>
                <th className="border-t border-gray-300 p-1 text-center">
                  No. Nights
                </th>
                <th className="border-t border-gray-300 p-1 text-center">
                  Rate Per N.
                </th>
                <th className="border-t border-gray-300 p-1 text-center">
                  CGST
                </th>
                <th className="border-t border-gray-300 p-1 text-center">
                  SGST
                </th>
              </tr>
            </thead>

            <tbody>
              {rows.map((r, i) => {
                const n = calcNights(r.checkin, r.checkout);
                const rate = Math.round(
                  Number(String(r.rate).replace(/,/g, "")) || 0,
                );
                const base =
                  Number(String(r.amount ?? "").replace(/,/g, "")) || rate * n;
                const rCgst = inclusiveGst
                  ? 0
                  : Number((base * 0.09).toFixed(2));
                const rSgst = inclusiveGst
                  ? 0
                  : Number((base * 0.09).toFixed(2));

                return (
                  <tr key={i}>
                    <td className="border-t border-gray-300 text-center">
                      {i + 1}
                    </td>
                    <td className="border-t border-l border-gray-300 text-center">
                      {r.property}
                    </td>
                    <td className="border-t border-gray-300 text-center">
                      {safeDate(r.checkin)}-{safeDate(r.checkout)}
                    </td>
                    <td className="border-t border-gray-300 text-center">
                      {n}
                    </td>
                    <td className="border-t border-gray-300 text-center">
                      ₹ {rate.toLocaleString("en-IN")}
                    </td>
                    <td className="border-t border-gray-300 text-center">
                      ₹ {rCgst.toLocaleString("en-IN")}
                    </td>
                    <td className="border-t border-gray-300 text-center">
                      ₹ {rSgst.toLocaleString("en-IN")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Totals */}
        <div className="flex justify-between mt-4">
          <div className="w-[60%] text-[11px] pr-5">
            {/* <p>
              <strong>Payment Method</strong>
              <br />
              Cash
            </p> */}

            <p className="mt-2">
              <strong>In Words</strong>
              <br />
              {totalWordsFormatted}
            </p>
          </div>

          <div className="w-[40%] flex justify-end -mt-2">
            <table className="text-[11px] w-[200px] border-collapse">
              <tbody>
                <tr className="border-b border-gray-300">
                  <td className="font-semibold">Sub Total</td>
                  <td className="text-right">
                    ₹ {subtotal.toLocaleString("en-IN")}
                  </td>
                </tr>
                {/* <tr className="border-b border-gray-300">
                  <td className="font-semibold">Security Deposit</td>
                  <td className="text-right">
                    ₹ {roundedSecurityDeposit.toLocaleString("en-IN")}
                  </td>
                </tr> */}
                <tr className="border-b border-gray-300">
                  <td className="font-semibold">GST</td>
                  <td className="text-right">
                    {inclusiveGst ? "₹" : "₹"}
                    {totgst.toLocaleString("en-IN")}
                  </td>
                </tr>

                <tr className="border-b border-gray-300">
                  <td className="font-bold">Total</td>
                  <td className="text-right font-bold">
                    ₹ {roundedTotal.toLocaleString("en-IN")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Signature */}
        <div className="mt-20 text-right text-[11px]">
          <p className="mr-20">Signature</p>
          <p className="mr-16 font-semibold">Zorba Stays</p>
        </div>

        {/* Payment Info */}
        {/* <div className="border-t border-gray-400 mt-4 pt-3 text-[11px] space-y-0.5">
          <p className="text-[14px] font-semibold">Payment Info</p>
          <p>HDFC Bank</p>
          <p>Ac No.: 50200077506738</p>
          <p>Ac Name: ZORBA STAYS</p>
          <p>IFSC: HDFC0000101</p>
          <p>Branch: RAJKOT - YAGNIK ROAD - GUJARAT</p>
          <p>Account Type: CURRENT</p>
        </div> */}
      </div>
    </div>
  );
};

export default InvoicePDF;
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { useSearchParams } from "react-router-dom";
// import { API_URL } from "../../Config";

// const InvoicePDF = () => {
//   const { bookingid } = useParams();
//   const [booking, setBooking] = useState(null);

//   useEffect(() => {
//     fetch(`${API_URL}/invoice/${bookingid}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) {
//           setBooking(data.data);
//         }
//       });
//   }, [bookingid]);
//   const [searchParams] = useSearchParams();
//   const autoprint = searchParams.get("autoprint") === "1";

//   useEffect(() => {
//     if (!booking || !autoprint) return;

//     const timer = setTimeout(() => {
//       window.print();
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, [booking, autoprint]);
//   useEffect(() => {
//     if (!autoprint) return;
//     const handleAfterPrint = () => {
//       window.close();
//     };
//     window.addEventListener("afterprint", handleAfterPrint);
//     return () => window.removeEventListener("afterprint", handleAfterPrint);
//   }, [autoprint]);

//   if (!booking) return <div>Loading...</div>;
//   const subtotal = Number(booking.btocprice || 0);
//   // const totgst = booking.totgst || 0;
//   const total = booking.finalprice || booking.totalprice || 0;
//   const roundedTotal = Math.round(total);
//   const proprice = booking.proprice || 0;
//   const roundedproprice = Math.round(proprice);

//   const securityDeposit = booking.secdep || 0;
//   const roundedSecurityDeposit = Math.round(securityDeposit);

//   // const cgst = subtotal * 0.09;
//   // const sgst = subtotal * 0.09;
//   // const totgst = cgst + sgst;
//   const inclusiveGst = booking.isinclusive === 1;

//   const cgst = inclusiveGst ? 0 : Number((subtotal * 0.09).toFixed(2));
//   const sgst = inclusiveGst ? 0 : Number((subtotal * 0.09).toFixed(2));
//   const totgst = Number((cgst + sgst).toFixed(2));
//   const displayGst = inclusiveGst ? -totgst : totgst;
//   const numberToWords = (num) => {
//     const belowTwenty = [
//       "",
//       "One",
//       "Two",
//       "Three",
//       "Four",
//       "Five",
//       "Six",
//       "Seven",
//       "Eight",
//       "Nine",
//       "Ten",
//       "Eleven",
//       "Twelve",
//       "Thirteen",
//       "Fourteen",
//       "Fifteen",
//       "Sixteen",
//       "Seventeen",
//       "Eighteen",
//       "Nineteen",
//     ];

//     const tens = [
//       "",
//       "",
//       "Twenty",
//       "Thirty",
//       "Forty",
//       "Fifty",
//       "Sixty",
//       "Seventy",
//       "Eighty",
//       "Ninety",
//     ];

//     const convertBelowThousand = (n) => {
//       let str = "";
//       if (n >= 100) {
//         str += belowTwenty[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }
//       if (n >= 20) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }
//       if (n > 0) {
//         str += belowTwenty[n] + " ";
//       }
//       return str.trim();
//     };

//     if (num === 0) return "Zero Rupees Only";

//     let result = "";

//     if (num >= 10000000) {
//       result += convertBelowThousand(Math.floor(num / 10000000)) + " Crore ";
//       num %= 10000000;
//     }

//     if (num >= 100000) {
//       result += convertBelowThousand(Math.floor(num / 100000)) + " Lakh ";
//       num %= 100000;
//     }

//     if (num >= 1000) {
//       result += convertBelowThousand(Math.floor(num / 1000)) + " Thousand ";
//       num %= 1000;
//     }

//     if (num > 0) {
//       result += convertBelowThousand(num);
//     }

//     return result.trim() + " Rupees Only";
//   };

//   const totalWordsFormatted = numberToWords(total);
//   const formatDate = (date) => new Date(date).toLocaleDateString("en-GB");

//   const nights =
//     Math.ceil(
//       (new Date(booking.checkout) - new Date(booking.checkin)) /
//         (1000 * 60 * 60 * 24),
//     ) || 0;

//   return (
//     <div className="p-3 bg-[#fafaf9] text-[12px] font-sans">
//       <div className="bg-[#fafaf9] p-5 rounded-lg max-w-[900px] mx-auto">
//         {/* Header */}
//         <div className="w-full flex justify-between mb-3">
//           {/* Left */}
//           <div className="w-[45%] pr-3">
//             <h1 className="text-[28px] font-semibold mb-2 ml-2">Invoice</h1>

//             <div className="ml-2 text-[11px] leading-4">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7c57c4a2-564b-4b83-62b0-761f834b5c00/public"
//                 alt="logo"
//                 className="h-[50px] w-auto my-2 block"
//               />

//               <p>306, 7 - Business Centrum</p>
//               <p>Amin Marg, Rajkot, 360001</p>
//               <p>GSTIN No.: 24AADFZ2976K1ZO</p>
//             </div>
//           </div>

//           {/* Middle */}
//           <div className="w-[30%] pt-10 text-[11px]">
//             <p className="font-semibold">Contact</p>
//             <p>
//               <a
//                 href="https://www.zorbastays.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-black no-underline"
//               >
//                 www.zorbastays.com
//               </a>
//             </p>
//             <p>+91 63552 31066</p>
//           </div>

//           {/* Right */}
//           <div className="w-[25%] flex justify-end">
//             <img
//               src="https://zorbastays.com/android-chrome-512x512.png"
//               //   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe4aa1c0-bc53-4764-85e9-7823b8961200/public"
//               alt="brand"
//               className="w-20 h-20 rounded-full"
//             />
//           </div>
//         </div>

//         <hr className="my-1" />

//         {/* Invoice Meta */}
//         <div className="flex justify-between text-[11px] my-2">
//           <div>
//             <p>Invoice No.</p>
//             <p className="font-semibold">{booking.bookingid}</p>
//           </div>
//           <div>
//             <p>Invoice Date</p>
//             <p className="font-semibold">
//               {new Date().toLocaleDateString("en-GB")}
//             </p>
//           </div>
//         </div>

//         <hr className="my-1" />

//         {/* Invoice To */}
//         <div className="mt-4">
//           <p className="text-[16px] font-semibold mb-1">Invoice To</p>
//           <p className="text-[18px] uppercase">
//             {booking.firstname} {booking.lastname}
//           </p>
//         </div>

//         {/* Table */}
//         <div className="mt-5 overflow-x-auto">
//           <table className="w-full border-collapse text-[11px] border-b border-gray-300">
//             <thead>
//               <tr>
//                 <th className="border-t border-gray-300 p-1 text-center">
//                   Sr. No.
//                 </th>
//                 <th className="border-t border-l border-gray-300 p-1 text-center">
//                   Particulars
//                 </th>
//                 <th className="border-t border-gray-300 p-1 text-center">
//                   Period of stay
//                 </th>
//                 <th className="border-t border-gray-300 p-1 text-center">
//                   No. Nights
//                 </th>
//                 <th className="border-t border-gray-300 p-1 text-center">
//                   Rate Per N.
//                 </th>
//                 <th className="border-t border-gray-300 p-1 text-center">
//                   CGST
//                 </th>
//                 <th className="border-t border-gray-300 p-1 text-center">
//                   SGST
//                 </th>
//               </tr>
//             </thead>

//             <tbody>
//               <tr key={booking.id}>
//                 <td className="border-t border-gray-300 text-center">1</td>

//                 <td className="border-t border-l border-gray-300 text-center">
//                   {booking.property}
//                 </td>

//                 <td className="border-t border-gray-300 text-center">
//                   {formatDate(booking.checkin)}-{formatDate(booking.checkout)}
//                 </td>

//                 <td className="border-t border-gray-300 text-center">
//                   {nights}
//                 </td>

//                 <td className="border-t border-gray-300 text-center">
//                   ₹ {roundedproprice.toLocaleString("en-IN")}
//                 </td>

//                 <td className="border-t border-gray-300 text-center">
//                   {/* ₹{(booking.cgst || 0).toLocaleString("en-IN")} */}₹{" "}
//                   {cgst.toLocaleString("en-IN")}
//                 </td>

//                 <td className="border-t border-gray-300 text-center">
//                   {/* ₹ {(booking.sgst || 0).toLocaleString("en-IN")} */}₹{" "}
//                   {sgst.toLocaleString("en-IN")}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Totals */}
//         <div className="flex justify-between mt-4">
//           <div className="w-[60%] text-[11px] pr-5">
//             {/* <p>
//               <strong>Payment Method</strong>
//               <br />
//               Cash
//             </p> */}

//             <p className="mt-2">
//               <strong>In Words</strong>
//               <br />
//               {totalWordsFormatted}
//             </p>
//           </div>

//           <div className="w-[40%] flex justify-end -mt-2">
//             <table className="text-[11px] w-[200px] border-collapse">
//               <tbody>
//                 <tr className="border-b border-gray-300">
//                   <td className="font-semibold">Sub Total</td>
//                   <td className="text-right">
//                     ₹ {subtotal.toLocaleString("en-IN")}
//                   </td>
//                 </tr>
//                 {/* <tr className="border-b border-gray-300">
//                   <td className="font-semibold">Security Deposit</td>
//                   <td className="text-right">
//                     ₹ {roundedSecurityDeposit.toLocaleString("en-IN")}
//                   </td>
//                 </tr> */}
//                 <tr className="border-b border-gray-300">
//                   <td className="font-semibold">GST</td>
//                   <td className="text-right">
//                     {inclusiveGst ? "₹" : "₹"}
//                     {totgst.toLocaleString("en-IN")}
//                   </td>
//                 </tr>

//                 <tr className="border-b border-gray-300">
//                   <td className="font-bold">Total</td>
//                   <td className="text-right font-bold">
//                     ₹ {roundedTotal.toLocaleString("en-IN")}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Signature */}
//         <div className="mt-20 text-right text-[11px]">
//           <p className="mr-20">Signature</p>
//           <p className="mr-16 font-semibold">Zorba Stays</p>
//         </div>

//         {/* Payment Info */}
//         {/* <div className="border-t border-gray-400 mt-4 pt-3 text-[11px] space-y-0.5">
//           <p className="text-[14px] font-semibold">Payment Info</p>
//           <p>HDFC Bank</p>
//           <p>Ac No.: 50200077506738</p>
//           <p>Ac Name: ZORBA STAYS</p>
//           <p>IFSC: HDFC0000101</p>
//           <p>Branch: RAJKOT - YAGNIK ROAD - GUJARAT</p>
//           <p>Account Type: CURRENT</p>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default InvoicePDF;
